import React, { useEffect, useState } from "react";
import { createMuiTheme } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBarBasic from "../layout/AppBar";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Alert from "@material-ui/lab/Alert";
import Scrollbar from "react-scrollbars-custom";
import CompanyDataService from "../../services/CompanyService";
import DepartmentForm from "./DepartmentForm";
import LocationForm from "./LocationForm";
import Copyright from "../layout/Copyright";
import { useStyles } from "../styles/useStyles";
import GroupForm from "./GroupForm";
import CompanyForm from "./CompanyForm";

const drawerWidth = 280;

class Style extends React.Component {
  getMuiTheme = () =>
    createMuiTheme({
      overrides: {
        MUIDataTable: {
          paper: {
            height: "inherit",
          },
          responsiveScroll: {
            maxHeight: "none",
          },
        },
      },
    });
}

export default function Events(props) {
  const classes = useStyles(props);

  const initialCompanyState = {
    id: null,
    name: "",
    phone: "",
    address: "",
    vat: "",
    owner: "",
    city: "",
  };
  const [currentCompany, setCurrentCompany] = useState(initialCompanyState);
  const [message, setMessage] = useState("");

  const getCompany = (id) => {
    CompanyDataService.get("1")
      .then((response) => {
        setCurrentCompany(response.data);
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    getCompany(props.match.params.id);
  }, [props.match.params.id]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setCurrentCompany({ ...currentCompany, [name]: value });
  };

  const updatePublished = (status) => {
    var data = {
      id: currentCompany.id,
      name: currentCompany.name,
      phone: currentCompany.phone,
      address: currentCompany.address,
      city: currentCompany.city,
      vat: currentCompany.vat,
      owner: currentCompany.owner,
      active: status,
    };

    CompanyDataService.update(currentCompany.id, data)
      .then((response) => {
        setCurrentCompany({ ...currentCompany, active: status });
        console.log(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const updateCompany = () => {
    CompanyDataService.update(currentCompany.id, currentCompany)
      .then((response) => {
        console.log(response.data);
        setMessage(
          <Alert severity="success">
            Фирмените данни бяха обновени успешно!
          </Alert>
        );
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const [open, setOpen] = React.useState(true);
  const handleClick = () => {
    setOpen(!open);
  };

  const currentHost = window.location.hostname;
  const isBluestar = currentHost === "bluestar.biodit.bg";

  const isAtliman = process.env.REACT_APP_HOTEL_NUMBER !== 19;

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBarBasic />
      <main className={classes.content}>
        <Scrollbar id="RSC-Example" style={{ width: "100%", height: "100%" }}>
          <div className={classes.appBarSpacer} />
          <Container maxWidth="lg" className={classes.container}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <CompanyForm />
              </Grid>
              {!isBluestar ||
                (isAtliman && (
                  <Grid item xs={4}>
                    <GroupForm />
                  </Grid>
                ))}
              <Grid item xs={4}>
                <LocationForm />
              </Grid>
              <Grid item xs={4}>
                <DepartmentForm />
              </Grid>
            </Grid>
          </Container>
          <Copyright />
        </Scrollbar>
      </main>
    </div>
  );
}

// export default connect(
//     mapStateToProps,
//     { logoutUser }
// )(Dashboard)
